/**
 * PRP-WEB-2 W2.5: subroom groups. The pure helpers are web-2-core's (W1.3, `@sketch-core`
 * groups.ts); this module adds what the page needs on top. A group is a main room and its
 * subrooms IN ORDER: the order is the Xactimate subroom number (F1, PF2 address subrooms by it,
 * founder 2026-11-02). Grouping never changes walls.
 */
import { addToGroup, groupOf, pruneGroups, removeFromGroup, reorderGroup, type GroupResult, type Groups } from '@sketch-core';

export { addToGroup, groupOf, pruneGroups, removeFromGroup, reorderGroup };
export type { GroupResult, Groups };

/** A room's subroom number (1..), or 0 when it is a main room or ungrouped. */
export const subNumber = (groups: Groups, rid: string): number => groupOf(groups, rid)?.order ?? 0;

export const sameGroups = (a: Groups, b: Groups): boolean => JSON.stringify(a) === JSON.stringify(b);
